/**
 * The exact words beside the text and call consent box, in the console and the app (V4
 * design mcConsText; AF-1566). The back end records the same words
 * (src/aithora/contact-consent.ts consentWordingFor); a unit test keeps the two identical.
 *
 * The box is unchecked by default and is not needed to save or verify a number. Ticked,
 * it records the person's own consent with the time, where (console or app) and these
 * words. Without it no alert texts or calls go to the number; push and in-app still do.
 */
export function consentWordingFor(role: string | null | undefined): string {
  const about = String(role ?? '').toUpperCase() === 'FAMILY_MEMBER' ? 'my family member’s care' : 'my work and urgent alerts';
  return `I agree Aithora may send me texts and automated calls about ${about} at this number. Message frequency varies. Message and data rates may apply. Reply STOP to opt out, HELP for help.`;
}

/**
 * The default words a prospect agrees to for the CRM's sales texts (recorded by the rep
 * from the contact card, with how it was given: verbal, paper or a web form). The back end
 * carries the same words (src/aithora/contact-consent.ts SALES_CONSENT_WORDING); a unit
 * test keeps the two identical. Sales consent never stands in for alert consent.
 */
export const SALES_CONSENT_WORDING =
  'I agree Aithora may send me sales and marketing texts at this number. Consent is not a condition of purchase. Message frequency varies. Message and data rates may apply. Reply STOP to opt out, HELP for help.';

/**
 * The words a family member agrees to before alerts about their family member come by
 * WhatsApp (purpose 'whatsapp'). The back end carries the same words
 * (src/aithora/contact-consent.ts WHATSAPP_CONSENT_WORDING); a unit test keeps the two
 * identical. WhatsApp consent never stands in for text and call consent, or the reverse.
 */
export const WHATSAPP_CONSENT_WORDING =
  'I agree Aithora may send me WhatsApp messages about my family member’s care at this number. The messages never name a health detail. Message frequency varies. Reply STOP to opt out.';
